import {
    CancelRounded,
    FilterAltOutlined,
    KeyboardArrowDown,
} from '@mui/icons-material';
import { t } from 'i18next';
import React, { memo } from 'react';

import { Button } from '@/components';
import { COLOR } from '@/theme/colors';

type Props = {
    isActive: boolean;
    isOpen: boolean;
    onToggle: VoidFunction;
    onClear: VoidFunction;
    testID: string;
};

function FilterToggleButton({
    isActive,
    isOpen,
    onToggle,
    onClear,
    testID,
}: Props) {
    return (
        <>
            <Button
                caption={t('Actions:filter')}
                color={isActive ? 'primary' : 'inherit'}
                onClick={onToggle}
                startIcon={<FilterAltOutlined />}
                endIcon={
                    <KeyboardArrowDown
                        sx={{
                            transition: 'transform 0.2s',
                            transform: isOpen ? 'rotate(180deg)' : undefined,
                        }}
                    />
                }
                sx={{
                    ml: 3,
                    fontWeight: 700,
                    height: 37,
                    borderColor: isActive ? undefined : COLOR.lightGray,
                    borderWidth: '1px',
                    borderRadius: '8px',
                    backgroundColor: isActive
                        ? COLOR.deepCerulean08
                        : undefined,
                    '&:hover': {
                        borderColor: COLOR.lightGray,
                        borderWidth: '1px',
                    },
                }}
                variant="outlined"
                data-test-id={testID}
            />
            {isActive ? (
                <Button
                    caption={t('Actions:clearFilters')}
                    onClick={onClear}
                    startIcon={<CancelRounded htmlColor={COLOR.paleSky} />}
                    sx={{
                        color: COLOR.paleSky,
                        fontWeight: 400,
                        ml: 3,
                    }}
                    data-test-id={`${testID}-Clear`}
                />
            ) : null}
        </>
    );
}

export default memo(FilterToggleButton);
